import { api } from '@/services/api';

import { UpdateTransactionDto } from '../transactions/transactions-types';
import { GetTableDto } from '@repo/common-types';
import {
  Pagination,
  TableDetailsDto,
  TableInfoDto,
  TableResponseDto,
  TableRestartReqDto,
  UserDto,
} from '@repo/common-types';
import { MixedTableDto, TableQueryDto } from './table-types';
import { formatUrl } from '@repo/common-types/src/utils/url-utils';
import { AxiosResponse } from 'axios';
import { TableStatus } from '@/common/types/phenomTypes';

export const updateTableTransactionRest = async (transactionId: string, params: UpdateTransactionDto) => {
  const response = await api.put(`/v1/admin/transactions/${transactionId}`, {
    params,
  });
  return response.data;
};

export const fetchTablesAllRest = async (GetTableDto: GetTableDto): Promise<TableResponseDto> => {
  const response = await api.get<TableResponseDto>(`/v1/admin/table`, {
    params: { ...GetTableDto },
  });
  return response.data;
};

export const fetchTableByIdRest = async (id: string, transactionPagination?: Pagination): Promise<TableDetailsDto> => {
  const response = await api.get(`/v1/admin/table/${id}/details`, { params: transactionPagination });
  return response.data;
};

export const fetchTableByIdSessions = async (id: string) => {
  const response = await api.get(`/v1/admin/table/${id}/sessions`);
  return response.data;
};

export const deletePlayersContractRest = async (id: string) => {
  const response = await api.delete(`/v1/admin/table/${id}/contract-players`);
  return response.data;
};

export const deletePlayerContractRest = async (tableId: string, amount: string | null, address: string) => {
  const response = await api.post(`/v1/admin/table/${tableId}/players/kick`, { amount, address });
  return response.data;
};

export const getPlayersContractRest = async (id: string): Promise<UserDto[]> => {
  const response = await api.get(`/v1/admin/table/${id}/contract-players`);
  return response.data;
};

export const updateTableRest = async (params: MixedTableDto) => {
  return await api.put<TableInfoDto>(`/v1/admin/table/${params.id}`, {
    params: params,
  });
};

export const restartTableRest = async (tableId: string, restartGameserver: boolean) => {
  return await api.post<undefined, AxiosResponse<undefined>, TableRestartReqDto>(`/v1/admin/table/${tableId}/restart`, {
    restartGameserver: restartGameserver,
  });
};

export const startTableHandRest = async (tournamentUrl: string, tableId: string, tournamentId: string) => {
  return await api.post<any>(
    `${formatUrl(tournamentUrl)}/admin/tournaments/${tournamentId}/start-hand/table/${tableId}`,
  );
};

export const startTableRest = async (tableId: string) => {
  return await api.post<any>(`/v1/admin/table/${tableId}/start`);
};

export const stopTableRest = async (tableId: string, force: boolean) => {
  return await api.post<any>(`/v1/admin/table/${tableId}/stop`, {
    params: force,
  });
};

export const tablePlayersPerDayRest = async (query: TableQueryDto) => {
  const response = await api.get<any>(`/v1/admin/table/analytics/players-per-day`, {
    params: query,
  });
  return response.data;
};

export const tableActivePlayersStatsRest = async () => {
  const response = await api.get<any>(`/v1/admin/table/analytics/active-players-stats`);
  return response.data;
};

export const tableWaitingPlayersStatsRest = async () => {
  const response = await api.get<any>(`/v1/admin/table/analytics/waiting-players-stats`);
  return response.data;
};

export const fetchTableDiffsRest = async () => {
  const response = await api.get<any>(`/v1/admin/table/table-sync`);
  return response.data;
};

export const fetchContractDiffsRest = async () => {
  const response = await api.get<any>(`/v1/admin/table/contract-sync`);
  return response.data;
};

export const transferFromTableRest = async (params: {
  contractAddress: string;
  contractId: string;
  amount: number;
  transactionType: string;
}) => {
  const response = await api.post<any>(`/v1/admin/table/transfer-from-table`, {
    ...params,
  });
  return response.data;
};

export const fundTableRest = async (params: {
  contractAddress: string;
  contractId: string;
  amount: number;
  transactionType: string;
}) => {
  const response = await api.post<any>(`/v1/admin/table/fund-table`, {
    ...params,
    approve: true,
  });
  return response.data;
};

export const updateTableStatusRest = async (tableId: string, status: TableStatus) => {
  return await api.put(`/v1/admin/table/${tableId}`, {
    params: {
      id: tableId,
      status,
    },
  });
};
